<mat-form-field color="accent">
	<mat-label>
		<mat-icon fontIcon="fa-palette" fontSet="fad" inline />
		{{ T.SELECT_COLOR | translate }}
	</mat-label>
	<mat-select class="selectedColor {{ ColorMapping[formCtrl()?.value] }}" [formControl]="formCtrl()">
		@for (eventColorKey of ColorKeys; track eventColorKey) {
			<mat-option [value]="eventColorKey" class="colorOption {{ ColorMapping[eventColorKey] }}">
				{{ T[Colors[eventColorKey]] | translate }}
			</mat-option>
		}
	</mat-select>
</mat-form-field>
